module.exports = __webpack_public_path__ + "img/talabbos_icon.d326971a.png";